import { renderRoutes } from 'react-router-config';
import { getRoutes, RFC } from 'configs/navigation';

const Settings: RFC = ({ route }) => {
  return renderRoutes(getRoutes(route));
};

export default Settings;
